/* eslint-disable */
// ============================================================
//  LOGO — HorseConnex
//
//  29 août 2026 : le logo etait stocke en base64 DANS ce fichier.
//  Un webp de 75 ko encode en texte occupait 100 ko du bundle principal,
//  et surtout il repartait chez tous les utilisateurs a CHAQUE nouvelle
//  version de l'app (on en sort plusieurs par semaine), alors qu'il n'a
//  pas change depuis des mois.
//
//  Il vit desormais dans public/logo.webp : le navigateur le met en cache
//  une fois et le garde d'une version a l'autre. Il est aussi precache par
//  le service worker, donc present des le premier lancement et hors ligne.
//
//  Il n'est utilise que comme source d'image (<img src={LOGO} />), jamais
//  dans un contexte qui exigerait une data URI — c'est ce qui rend le
//  remplacement sans risque. Si un jour un usage a besoin de l'image
//  embarquee (un canvas exporte, un email), il faudra la relire depuis ce
//  fichier, pas reintroduire du base64 ici.
// ============================================================

export const LOGO = `${process.env.PUBLIC_URL || ""}/logo.webp`;
